<template>
  <div class="rating">
    <span v-for="item in itemClasses"><i class="iconfont" :class="'icon-'+item"></i></span>
  </div>
</template>

<script>

  const LENGTH = 5;
  const CLS_ON = 'shiwujiaoxing';
  const CLS_HALF = 'pingfen1';
  const CLS_OFF = 'kongxing';

  export default {
    data: function () {
      return {}
    },
    props:{
      score:{
        default:0
      }
    },
    computed: {
      itemClasses:function () {
        let result = [];
        let score = Math.floor(this.score * 2) / 2;
        let hasDecimal = score % 1 !== 0;
        let integer = Math.floor(score);
        for (let i = 0; i < integer; i++) {
          result.push(CLS_ON);
        }
        if (hasDecimal) {
          result.push(CLS_HALF);
        }
        while (result.length < LENGTH) {
          result.push(CLS_OFF);
        }
        return result;
      }

    },
    mounted(){
    },
    methods: {}
  }
</script>

<style lang="stylus" scoped>
.rating
  height 20px
  color #548EDF
  display inline
  font-size 14px
</style>



// WEBPACK FOOTER //
// src/components/globalComp/rating.vue